export enum GlobalSearchInputSize {
  large = 'large',
  medium = 'medium',
}

export type SizeScheme = {
  [key in keyof typeof GlobalSearchInputSize]: {
    fontSize: string;
    lineHeight: number;
    height: string;
    paddingBlock: number;
  };
};
